import { Loader2Icon } from 'lucide-react'

import { cn } from '@/utils'

// What the still-dimmed content is waiting for: the strip has not stopped, so the statement under
// its left edge is not decided yet.
export const PENDING_DIM = 'pointer-events-none opacity-50'

export const LOADING_FILES = 'Loading the files…'

interface PendingNoteProps {
  text?: string
  className?: string
}

export const PendingNote = ({
  text = 'Finding the statement…',
  className,
}: PendingNoteProps) => (
  <p
    data-pending-note
    className={cn(
      'flex items-center gap-1.5 whitespace-nowrap text-xs text-ink-subtle',
      className,
    )}
  >
    <Loader2Icon className="size-3 animate-spin" />
    {text}
  </p>
)
